/**
 * @flow
 * @relayHash a8c9911af093f5c8fe3c1e738e9488fc
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateOrganizationRoleInput = {|
  id: string,
  name: string,
  clientMutationId?: ?string,
|};
export type CreateRoleMutationVariables = {|
  input: CreateOrganizationRoleInput
|};
export type CreateRoleMutationResponse = {|
  +createOrganizationRole: ?{|
    +newOrganizationRole: ?{|
      +id: string
    |}
  |}
|};
export type CreateRoleMutation = {|
  variables: CreateRoleMutationVariables,
  response: CreateRoleMutationResponse,
|};
*/


/*
mutation CreateRoleMutation(
  $input: CreateOrganizationRoleInput!
) {
  createOrganizationRole(input: $input) {
    newOrganizationRole {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateOrganizationRoleInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createOrganizationRole",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOrganizationRolePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "newOrganizationRole",
        "storageKey": null,
        "args": null,
        "concreteType": "OrganizationRoleNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateRoleMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateRoleMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateRoleMutation",
    "id": null,
    "text": "mutation CreateRoleMutation(\n  $input: CreateOrganizationRoleInput!\n) {\n  createOrganizationRole(input: $input) {\n    newOrganizationRole {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd0ceacf78fe861790bcbc75920c04039';
module.exports = node;
